import AxiosApi from "./configApi";

if (process.env.REACT_APP_USERADMIN_URL === undefined)
  throw Error("REACT_APP_USERADMIN_URL is not configured");

const urlUserAdmin = process.env.REACT_APP_USERADMIN_URL;

const endpoints_userAdmin = {
  ADMINUSERS: "user",
  USER_EMAIL: "user/byname",
};

const endpoints_answerAdmin = {
  ANSWER_BY_AUDIT: "answer/by-audit",
};

const endpoints_auditAdmin = {
  AUDIT: "audit",
  AUDIT_BY_LOCAL: "audit/by-local",
  AUDIT_BY_LOCAL_ORDER: "audit/by-local-order",
  AUDIT_BY_ID: "audit/by-id",
  AUDIT_PDF: "audit/pdf",
  EXPORT_BPM: "pdf/exportbpm",
  EXPORT_IMAGES_REPORT: "pdf/export-images-report",
  EXPORT_REPORT: "pdf/export-report",
};

const endpoints_empAdmin = {
  EMPADMIN: "empadmin",
  EMPADMIN_NOM: "empadmin/byname",
};

const endpoints_clasification = {
  CLASIFICATION: "clasification",
};

const endpoints_alerts = {
  ALERT: (localId) => `alert/${localId}`,
  ALERT_REPORT: 'audit/by-local-alert',
};

const endpoints_inputValue = {
  INPUTVALUE: "inputvalue",
  REPORTQUESTION: "inputvalue/reportQuestion",
  BYREPORT: "inputvalue/report",
};

const endpoints_localAdmin = {
  LOCAL: "local",
  LOCAL_NOM: "local/byname",
  LOCAL_BY_ID: (id) => `local/${id}`,
};

const endpoints_predictive_model = {
  POST_ALERT: "alert",
  GET_REPORT: "get_report",
  UPDATE_ALERT: "audit/update-alert-by-local",
};

const endpoints_question = {
  QUESTION: "question",
};

const endpoints_report = {
  REPORT: "report",
  REPORTBYLOCAL: "report/local",
  REPORTBYAUDITOR: "report/auditor",
  REPORTBYSUPERVISOR: "report/supervisor",
  REPORTBYSUPERVISORHISTORICO: "report/supervisorHistorico",
  REPORTBYCLIENTRHISTORICO: "report/clienteHistorico",
  REPORTBYSUPERVISORSTATUS: (id, status) => {
    return "report/supervisor/" + id + "/" + status;
  },
};

const endpoints_userAuthApi = {
  LOGIN: "login",
  VERIFY: "autorizated",
};

const endpoints_supervisor = {
  LOCALS: "local/supervisor",
};

const endpoints_userLocal = {
  USERLOCAL: "userlocal",
  USERLOCALBYUSERID: (id) => {
    return "userlocal/byUser/" + id;
  },
  USERLOCALBYEMPADMIN: (id) => {
    return "userlocal/empAdmin/" + id;
  },
  CHART: "chart",
};

const endpoints_clientResponse = {
  CLIENT_RESPONSE: "clientResponse",
  CLIENT_RESPONSE_AUDIT: (auditId) => `clientResponse/by-audit/${auditId}`,
};

class ApiUserAdmin {
  base_url = urlUserAdmin;
  api = new AxiosApi();

  get = async (endpoint, pk) => {
    const items = await this.api.get(
      this.base_url + endpoint + (pk ? `/${pk}` : "")
    );
    return items;
  };

  post = async (endpoint, payload) => {
    const items = await this.api.post(this.base_url + endpoint, payload);
    return items;
  };

  put = async (endpoint, pk, payload) => {
    const completeEndpoint = `${this.base_url}${endpoint}/${pk}`;
    const items = await this.api.put(completeEndpoint, payload);

    return items;
  };

  delete = async (endpoint, pk) => {
    const completeEndpoint = `${this.base_url}${endpoint}/${pk}`;
    const items = await this.api.delete(completeEndpoint);
    return items;
  };

  postUpload = async (endpoint, payload, file) => {
    const formData = new FormData();

    // Agregamos campos del payload
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    // Agregamos el archivo si existe
    if (file) {
      formData.append("photo", file);
    }

    const items = await this.api.post(this.base_url + endpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return items;
  };

  postBlob = async (endpoint, payload) => {
    const response = await this.api.post(this.base_url + endpoint, payload, {
      responseType: "blob", // importante
    });
    return response; // Axios devuelve { data, status, headers }
  };
}

export {
  ApiUserAdmin,
  endpoints_userAdmin,
  endpoints_answerAdmin,
  endpoints_auditAdmin,
  endpoints_empAdmin,
  endpoints_clasification,
  endpoints_alerts,
  endpoints_inputValue,
  endpoints_localAdmin,
  endpoints_predictive_model,
  endpoints_question,
  endpoints_report,
  endpoints_userAuthApi,
  endpoints_userLocal,
  endpoints_clientResponse,
  endpoints_supervisor,
};
